var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('div', {
    staticClass: "handle-left"
  }, [_c('Input', {
    staticStyle: {
      "width": "230px",
      "margin-right": "20px"
    },
    attrs: {
      "search": "",
      "placeholder": "搜索客户...",
      "clearable": "",
      "icon": "ios-search"
    },
    on: {
      "on-change": _vm.searchCustomer
    },
    model: {
      value: _vm.searchText,
      callback: function ($$v) {
        _vm.searchText = $$v;
      },
      expression: "searchText"
    }
  }), _c('DatePicker', {
    staticStyle: {
      "width": "100px",
      "margin-right": "8px"
    },
    attrs: {
      "type": "month",
      "placement": "bottom-end",
      "placeholder": "选择月份"
    },
    on: {
      "on-change": _vm.changeDate
    },
    model: {
      value: _vm.yearMonth,
      callback: function ($$v) {
        _vm.yearMonth = $$v;
      },
      expression: "yearMonth"
    }
  }), _c('Button', {
    staticStyle: {
      "margin-right": "12px"
    },
    attrs: {
      "type": "default"
    },
    on: {
      "click": function ($event) {
        return _vm.loadSalesOrderProfit();
      }
    }
  }, [_vm._v("刷新")])], 1), _c('div', {
    staticClass: "handle-right"
  }, [_c('div', {
    staticClass: "page-wrap"
  }, [_c('span', [_vm._v("共" + _vm._s(_vm.salesOrderProfitTotalCounts) + "条")]), _c('Page', {
    staticStyle: {
      "min-width": "160px"
    },
    attrs: {
      "total": Number(_vm.salesOrderProfitTotalCounts),
      "page-size": _vm.limit,
      "show-total": "",
      "simple": ""
    },
    on: {
      "on-change": _vm.loadSalesOrderProfit
    }
  })], 1), _c('Button', {
    staticStyle: {
      "margin-right": "12px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.calcSalesOrderProfitMethed
    }
  }, [_vm._v("计算订单利润")]), _c('Button', {
    staticStyle: {
      "margin-right": "12px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.coverSalesOrdersCalcMethed
    }
  }, [_vm._v("覆盖之前数据")])], 1)]), _c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('Table', {
    attrs: {
      "columns": _vm.columns,
      "height": _vm.tableHeight - 50,
      "loading": _vm.tableLoading,
      "data": _vm.salesOrderProfitList,
      "summary-method": _vm.handleSummary,
      "show-summary": "",
      "border": ""
    }
  })], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }